import { useSearchParams } from 'react-router-dom';
import usePricelineStore from './priceline';
import useSearchStore from './search';
import useForaStore from './fora';
import useChainStore from './chain';

const useSearchHooks = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const search = useSearchStore((state) => state);
  const getChainList = useChainStore((state) => state.getChainList);
  const { search: pricelineSearch, setPage, clientSideFilter } = usePricelineStore((state) => ({
    search: state.search,
    setPage: state.setPage,
    clientSideFilter: state.clientSideFilter,
  }));
  const { search: foraSearch, setPage: setPageFora } = useForaStore((state) => ({
    search: state.search,
    setPage: state.setPage,
  }));

  const filterSearchPriceline = async () => {
    search.setParams({ page: 0 });
    const s = useSearchStore.getState();
    await pricelineSearch(s);
  };

  const filterSearchFora = async () => {
    search.setParams({ pageVip: 0, limitVip: 4, page: 1 });
    const s = useSearchStore.getState();
    await foraSearch(s);
  };
  const filterSearch = async () => {
    search.setParams({ pageVip: 0, limitVip: 4, page: 1 });
    const s = useSearchStore.getState();
    await Promise.all([pricelineSearch(s), foraSearch(s)]);
  };
  const startSearch = async () => {
    await filterSearch();
    const s = useSearchStore.getState();
    await getChainList(s);
  };

  const setPricelinePage = (page) => {
    search.setParams({ page });
    setPage(page);
  };

  const setSearchParameters = (params) => {
    search.setParams(params);
    const parameters = Object.fromEntries(searchParams.entries());
    setSearchParams({ ...parameters, ...params });
  };

  const getForaMore = async () => {
    setPageFora({ ...search, limitVip: 8, pageVip: +search.pageVip + +search.limitVip });
    console.log('getForaMore');
    search.setParams({ limitVip: 8, pageVip: +search.pageVip + +search.limitVip });
  };

  const setChain = (chain) => {
    search.setParams(chain);
    filterSearch();
  };

  const setStar = (star) => {
    console.log(star);
    setSearchParameters(star);
    filterSearch();
  };

  const setAmenities = (amenities) => {
    setSearchParameters(amenities);
    filterSearchPriceline();
  };

  const setBudgetStart = (budgetStart) => {
    setSearchParameters(budgetStart);
    clientSideFilter(useSearchStore.getState());
  };

  const setBudgetEnd = (budgetEnd) => {
    setSearchParameters(budgetEnd);
    clientSideFilter(useSearchStore.getState());
  };

  const setHotelName = (hotelName) => {
    setSearchParameters(hotelName);
    clientSideFilter(useSearchStore.getState());
    filterSearchFora();
  };

  const setShortingBy = (shortingBy) => {
    const state = useSearchStore.getState();
    const newState = { ...state, sortingBy: shortingBy };
    setSearchParameters({ sortingBy: shortingBy });
    search.setParams({ pageVip: 0, limitVip: 4, page: 1 });
    clientSideFilter(newState);
  };

  return {
    startSearch,
    setPricelinePage,
    getForaMore,
    setChain,
    setStar,
    setSearchParameters,
    setAmenities,
    setBudgetStart,
    setBudgetEnd,
    setHotelName,
    setShortingBy,
    search,
  };
};

export default useSearchHooks;
